import { useEffect } from 'react';
import '../../features/components/Hero.css';

export default function Hero() {
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const one = document.querySelector('.services-hero .one') as HTMLElement;
      const two = document.querySelector('.services-hero .two') as HTMLElement;
      const three = document.querySelector('.services-hero .three') as HTMLElement;
      const four = document.querySelector('.services-hero .four') as HTMLElement;
      const five = document.querySelector('.services-hero .five') as HTMLElement;
      if (one) one.style.bottom = `${-(scrollTop * 0.3)}px`;
      if (two) two.style.bottom = `${-(scrollTop * 0.4)}px`;
      if (three) three.style.bottom = `${-(scrollTop * 0.5)}px`;
      if (four) four.style.bottom = `${-(scrollTop * 0.6)}px`;
      if (five) five.style.bottom = `${-(scrollTop * 0.7)}px`;
    };

    const handleMouseMove = (e: MouseEvent) => {
      const cx = window.innerWidth / 2;
      const cy = window.innerHeight / 2;
      const x = ((cx - e.pageX) / cx) * 2;
      const y = ((cy - e.pageY) / cy) * 2;
      const two = document.querySelector('.services-hero .two') as HTMLElement;
      const four = document.querySelector('.services-hero .four') as HTMLElement;
      const five = document.querySelector('.services-hero .five') as HTMLElement;
      if (two) two.style.transform = `translate(${x}px, ${y}px)`;
      if (four) four.style.transform = `translate(-${x}px, ${y}px)`;
      if (five) five.style.transform = `translate(${x}px, -${y}px)`;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    const section = document.querySelector('.services-hero');
    if (section) {
      section.addEventListener('mousemove', handleMouseMove as (e: Event) => void, { passive: true });
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (section) {
        section.removeEventListener('mousemove', handleMouseMove as (e: Event) => void);
      }
    };
  }, []);

  const handleContactClick = () => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE('/contact');
  };

  const handlePricingClick = () => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE('/pricing');
  };

  return (
    <section className="services-hero relative pt-32 pb-20 overflow-hidden bg-brand-color">
      <div className="parallax">
        <div className="one" />
        <div className="two" />
        <div className="three" />
        <div className="four" />
        <div className="five" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 border border-white/30 rounded-full mb-8 shadow-sm backdrop-blur-sm">
            <i className="ri-leaf-line text-white text-lg" />
            <span className="text-sm font-semibold text-white">Professionelle Webdesign-Leistungen</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-6 leading-tight text-white">
            Meine Leistungen
            <br />
            <span className="text-brand-green-light">im Detail</span>
          </h1>

          <p className="text-lg md:text-xl text-white/80 mb-10 leading-relaxed max-w-3xl mx-auto">
            Von der <strong className="text-white">Webseiten-Erstellung</strong> über{' '}
            <strong className="text-white">AI Chatbot Integration</strong> bis zur{' '}
            <strong className="text-white">SEO Optimierung</strong> – maßgeschneiderte digitale Lösungen für nachhaltigen Online-Erfolg.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={handleContactClick}
              className="group px-8 py-4 bg-brand-green text-white font-semibold rounded-lg transition-all duration-300 shadow-md hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <span>Kostenloses Erstgespräch</span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={handlePricingClick}
              className="px-8 py-4 bg-white/20 text-white font-semibold rounded-lg border-2 border-white/40 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-sm backdrop-blur-sm"
            >
              Preise ansehen
            </button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-8 border-t border-white/20">
            {[
              { icon: 'ri-map-pin-2-line', label: 'Lokal im Schwarzwald' },
              { icon: 'ri-time-line', label: 'Antwort in 24h' },
              { icon: 'ri-shield-check-line', label: '100% Zufriedenheitsgarantie' },
            ].map(({ icon, label }) => (
              <div key={label} className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${icon} text-white text-xl`} />
                </div>
                <span className="text-sm text-white/80 font-medium">{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
